import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router'
// import { SimpleGlobal } from 'ngx-simple-global'
import { HttpClient } from '@angular/common/http';
import { UserService } from 'app/services/user/user.service';
import { Web3Service } from 'app/services/web3/web3.service';
import { ContractsService } from 'app/services/contract/contracts.service';
import { eContracts } from 'app/services/contract/contract.config';
import { SimpleStorageService } from 'app/services/storage/simple-storage.service';
import { environment } from 'environments/environment';
declare const analytics
@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OnboardingComponent implements OnInit {

  public stepText
  public stepTitle
  public showOnboardingProgress
  public stepNumber
  public stepItem: any = [false, false, false]
  // public account
  public showStartAgain
  wallet: string;
  web3: any;
  constructor(
    private http: HttpClient,
    private router: Router,
    // private activeRoute: ActivatedRoute,
    // private sg: SimpleGlobal,
    private simpleStorageService: SimpleStorageService,
    private userService: UserService,
    private web3Service: Web3Service,
    private contractsService: ContractsService,
  ) {
    //this.enableNavBar();

    // if (this.appComponent.accounts == undefined) {
    //   this.appComponent.accountsObservable.subscribe((item: any) => {
    //     this.wallet = item[0];
    //     //this.routerRules()
    //     //this.checkSteps();
    //   });
    // } else {
    //   this.wallet = this.appComponent.accounts[0];
    //   //this.routerRules()
    //   //this.checkSteps();
    //   //this.convertBNBtoKMON();
    // }
    this.wallet = this.userService._userInfoData.recordedWallet;
    this.web3 = this.web3Service.getWeb3();
    this.showOnboardingProgress = false;
    this.showStartAgain = true;
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        if (val.url.indexOf('find') != -1 || val.url.indexOf('balancefill') != -1 || val.url.indexOf('first-kryptomon') != -1 || val.url.indexOf('first-lootbox') != -1) {
          this.showOnboardingProgress = true;
          if (val.url.indexOf('find') >= 0) {
            this.stepItem = [false, false, false]
            this.stepNumber = 0;
          } else if (val.url.indexOf('first-lootbox') >= 0) {
            this.stepItem = [true, false, false]
            console.log(this.stepItem)
            this.stepNumber = 1;
          } else if (val.url.indexOf('balancefill') >= 0) {
            this.stepItem = [true, true, false]
            console.log(this.stepItem)
            this.stepNumber = 2;
          }
        } else if (val.url.indexOf('pick-starter') >= 0) {
          this.showStartAgain = false;
          this.showOnboardingProgress = false
        } else {
          this.showOnboardingProgress = false
        }
      }
    })

    console.log(this.stepItem)
    this.simpleStorageService.setSimple('steps', [false, false, false]);
  }

  ngOnInit(): void {
  }

  goToStep(step, index) {
    console.log(index)
    console.log(this.stepNumber)
    if (index > 0) {
      let currentStep = index - 1;
      // console.log(this.sg['steps'][currentStep])
      // console.log(this.sg['steps'][index])
      // if ((this.sg['steps'][currentStep])) {
      if ((this.simpleStorageService.getSimple('steps')[currentStep])) {
        console.log('qua')
        this.router.navigate(['/onboarding/' + step])
      } else if (this.stepNumber >= index) {
        console.log('bigger')
        this.router.navigate(['/onboarding/' + step])
      }
    } else if (index == 0) {
      this.router.navigate(['/onboarding/' + step])
    }

  }

  async checkSteps() {
    const balance = await this.contractsService.getContract(eContracts.KMON).methods.balanceOf(this.wallet).call();
    const balanceBnb = await this.web3.eth.getBalance(this.wallet);
    let kmonBalance = await parseFloat(this.web3.utils.fromWei(balance))
    let bnbBalance = await parseFloat(this.web3.utils.fromWei(balanceBnb))

    if (kmonBalance >= 2500 && bnbBalance >= 0.02) {
      // this.sg['steps'][1] = true;
      let steps = this.simpleStorageService.getSimple('steps');
      steps[1] = true;
      this.simpleStorageService.setSimple('steps', steps);
    }

    console.log('getKryptomons')
    await this.contractsService.getContract(eContracts.KMONFT).methods.ownedKryptomons().call({ from: this.wallet }).then((receipt) => {
      if (receipt.length > 0) {
        // this.sg['steps'][0] = true;
        // this.sg['steps'][2] = true;
        // this.sg['hasKryptomon'] = true;
        let steps = this.simpleStorageService.getSimple('steps');
        steps[0] = true;
        steps[2] = true;
        this.simpleStorageService.setSimple('hasKryptomon', true);
      }
      this.contractsService.getContract(eContracts.KMONFTV2).methods.ownedKryptomons().call({ from: this.wallet }).then((receipt) => {
        if (receipt.length > 0) {
          // this.sg['steps'][0] = true;
          // this.sg['steps'][2] = true;
          // this.sg['hasKryptomon'] = true;
          let steps = this.simpleStorageService.getSimple('steps');
          steps[0] = true;
          steps[2] = true;
          this.simpleStorageService.setSimple('hasKryptomon', true);
        }
      })
    })

    this.http.get(environment.apiBaseUrl + "auth/getBoxes.php?address=" + this.wallet).subscribe((item: any) => {
      if (item.length > 0) {
        // this.sg['steps'][3] = true;
        let steps = this.simpleStorageService.getSimple('steps');
        steps[3] = true;
        this.simpleStorageService.setSimple('hasKryptomon', true);
      }
    })
    console.log('steps from simple storage', this.simpleStorageService.getSimple('steps'))
  }

  skipOnboarding() {
    analytics.track('clicked button', { section: 'onboarding', value: "skip" });
    this.setCookie('skip-onboarding', true, 30);
    this.router.navigate(['/kryptomons'])
  }

  startAgain() {
    this.router.navigate(['/onboarding/start'])
    analytics.track('Exited Onboarding', {
      section: 'onboarding-f2p',
      value: 'start again'
    });
  }

  setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 60 * 1000 * 60 * 24));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
    console.log('cookie-set')
  }

}
